export interface SiteLink {
  href: string;
  label: string;
  mobileLabel?: string;
  title: string;
  external?: boolean;
}

// All site links keyed by ID
export const SITE_LINKS = {
  // Products
  matic: { href: "/product", label: "Matic", title: "Matic" },
  accessories: {
    href: "/accessories",
    label: "Accessories",
    title: "Accessories",
  },

  // Resources
  support: {
    href: "https://support.maticrobots.com/",
    label: "Support",
    title: "Support",
    external: true,
  },
  orderStatus: {
    href: "/order-status",
    label: "Order Status",
    title: "Where's my Matic?",
  },
  faq: { href: "/product#faq", label: "FAQ", title: "FAQ" },
  blog: { href: "/blog", label: "Blog", title: "Blog" },
  warranty: { href: "/warranty", label: "Warranty", title: "Warranty" },
  returnPolicy: {
    href: "/return-policy",
    label: "Return Policy",
    mobileLabel: "Returns",
    title: "Return Policy",
  },
  hsaFsa: {
    href: "/hsa-fsa",
    label: "HSA/FSA",
    title: "Pay with HSA/FSA",
  },

  // Company
  company: { href: "/company", label: "Company", title: "Company" },
  careers: { href: "/careers", label: "Careers", title: "Careers" },
  terms: { href: "/terms", label: "Terms", title: "Terms" },
  privacy: {
    href: "/privacy-policy",
    label: "Privacy Policy",
    title: "Privacy Policy",
  },
  // CPRA-recognized opt-out link text.
  privacyChoices: {
    href: "/privacy-choices",
    label: "Your Privacy Choices",
    title: "Your Privacy Choices",
  },
  press: { href: "/press", label: "Press Kit", title: "Press Kit" },
  contact: {
    href: "/contact-us",
    label: "Contact Us",
    title: "Contact Us",
  },
  accessibility: {
    href: "/accessibility",
    label: "Accessibility",
    title: "Accessibility",
  },
  sitemap: { href: "/sitemap", label: "Sitemap", title: "Sitemap" },

  // Socials
  twitter: {
    href: "https://twitter.com/maticrobots",
    label: "X",
    title: "Matic on X (formerly Twitter)",
    external: true,
  },
  instagram: {
    href: "https://www.instagram.com/maticrobots/",
    label: "Instagram",
    title: "Instagram",
    external: true,
  },
  linkedin: {
    href: "https://www.linkedin.com/company/matician",
    label: "LinkedIn",
    title: "LinkedIn",
    external: true,
  },
} as const satisfies Record<string, SiteLink>;

export type SiteLinkId = keyof typeof SITE_LINKS;
